import { Platform, type TextStyle } from 'react-native';
import { appTheme } from '../../../shared/theme';
import { DASH_STUDIO_INNER } from '../../../shared/theme/studio/dashboardConstants';

export const CALENDAR_PADDING = 16;

/** Match `CalendarScreen` scroll (`DASH_STUDIO_INNER`) + card inner horizontal padding. */
export const CAL_GRID_H_TRIM = 2 * DASH_STUDIO_INNER + 2 * appTheme.spacing.md;

/** Gap between date cells in the grid. */
export const CALENDAR_GRID_GAP = 6;

/** Minimum cell size (px) so cells stay tappable on narrow screens. */
export const CALENDAR_CELL_SIZE_MIN = 32;

/** Unified corner radius for every date tile in the v3 grid. */
export const CALENDAR_CELL_BORDER_RADIUS = 10;

/** Reserved slot under the day number so all cells stay the same height. */
export const CALENDAR_CELL_ICON_SIZE = 12;

/** Extra vertical room so animated cells (scale/bob) are not clipped on Android. */
export const CALENDAR_GRID_ANIMATION_INSET = Platform.OS === 'android' ? 4 : 2;

/** Android trims extra font padding that misaligns day numbers vs icons. */
export const CALENDAR_ANDROID_TEXT_COMPACT: TextStyle =
  Platform.OS === 'android' ? { includeFontPadding: false, textAlignVertical: 'center' } : {};

export function computeCalendarCellSize(window_width: number): number {
  return Math.max(
    CALENDAR_CELL_SIZE_MIN,
    Math.round((window_width - CAL_GRID_H_TRIM - 6 * CALENDAR_GRID_GAP) / 7),
  );
}
